var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-body"},[_c('div',{staticClass:"app-header"},[_c('the-header'),_c('h1',[_vm._v(_vm._s(_vm.$t('lk.title')))])],1),_c('div',{staticClass:"main"},[_c('the-nav-admin'),_c('admin-panel')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }